import { FileType } from "./FolderFile.dto";

type FileTypeLowerCase = Lowercase<keyof typeof FileType>;

export function ReadableFileExt(mime: string): FileTypeLowerCase {
  switch (mime) {
    case "image/png":
      return "png";
    case "image/jpeg":
      return "jpg";
    case "application/pdf":
      return "pdf";
    case "application/msword":
      return "doc";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/haansoftxlsx":
      return "xlsx";
    case "application/vnd.ms-excel.12":
      return "xlsx";
    case "application/xml":
      return "xml";
    case "text/xml":
      return "xml";
    case "application/zip":
      return "zip";
    case "application/x-compress":
      return "zip";
    case "application/x-compressed":
      return "zip";
    case "application/x-zip-compressed":
      return "zip";
    case "multipart/x-zip":
      return "zip";
    case "application/dicom":
      return "dcm";
    case "image/bmp":
      return "bmp";
    case "image/x-ms-bmp":
      return "bmp";
    case "text/plain":
      return "txt";
    case "image/tiff":
      return "tiff";
    default:
      return "unknown";
  }
}
